(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$fieldRows = document.querySelectorAll(".field-row");
var $197cd56b15c33885$var$winner = document.getElementsByClassName("field-cell--2048");
var $197cd56b15c33885$var$board;
var $197cd56b15c33885$var$score = 0;
var $197cd56b15c33885$var$rows = 4;
var $197cd56b15c33885$var$columns = 4;
var $197cd56b15c33885$var$tilesMoved = false;
window.onload = function() {
    $197cd56b15c33885$var$setGame();
};
function $197cd56b15c33885$var$setGame() {
    $197cd56b15c33885$var$board = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    for(var r = 0; r < $197cd56b15c33885$var$fieldRows.length; r++){
        var fieldRowCells = $197cd56b15c33885$var$fieldRows[r].querySelectorAll(".field-cell");
        for(var c = 0; c < fieldRowCells.length; c++){
            fieldRowCells[c].id = "".concat(r, "-").concat(c);
            var num = $197cd56b15c33885$var$board[r][c];
            $197cd56b15c33885$var$updateTile(fieldRowCells[c], num);
        }
    }
}
function $197cd56b15c33885$var$hasEmptyTile() {
    for(var r = 0; r < $197cd56b15c33885$var$rows; r++)for(var c = 0; c < $197cd56b15c33885$var$columns; c++){
        if ($197cd56b15c33885$var$board[r][c] === 0) return true;
    }
    return false;
}
function $197cd56b15c33885$var$searchWinnerCell() {
    if ($197cd56b15c33885$var$winner.length !== 0) $197cd56b15c33885$var$messageWin.classList.remove("hidden");
}
function $197cd56b15c33885$var$setTwoTiles() {
    if (!$197cd56b15c33885$var$hasEmptyTile()) return;
    var found = false;
    while(!found){
        var randomCellNumber = Math.random() <= 0.1 ? 4 : 2;
        var r = Math.floor(Math.random() * $197cd56b15c33885$var$rows);
        var c = Math.floor(Math.random() * $197cd56b15c33885$var$columns);
        if ($197cd56b15c33885$var$board[r][c] === 0) {
            $197cd56b15c33885$var$board[r][c] = randomCellNumber;
            var tile = document.getElementById("".concat(r, "-").concat(c));
            tile.innerText = "".concat(randomCellNumber);
            tile.classList.add("field-cell--".concat(randomCellNumber));
            found = true;
        }
    }
}
function $197cd56b15c33885$var$updateTile(tile, num) {
    tile.innerText = "";
    tile.classList.value = "field-cell";
    if (num > 0) {
        tile.innerText = num;
        tile.classList.add("field-cell--".concat(num));
    }
}
$197cd56b15c33885$var$button.addEventListener("click", function() {
    for(var r = 0; r < $197cd56b15c33885$var$rows; r++){
        for(var c = 0; c < $197cd56b15c33885$var$columns; c++){
            var tile = document.getElementById("".concat(r, "-").concat(c));
            tile.innerText = "";
            tile.classList.value = "field-cell";
            $197cd56b15c33885$var$board[r][c] = 0;
        }
        $197cd56b15c33885$var$score = 0;
        document.querySelector(".game-score").innerText = 0;
    }
    $197cd56b15c33885$var$setTwoTiles();
    $197cd56b15c33885$var$setTwoTiles();
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$button.classList.remove("start");
    $197cd56b15c33885$var$button.classList.add("restart");
    $197cd56b15c33885$var$button.innerText = "Restart";
});
document.addEventListener("keyup", function(e) {
    if (e.code === "ArrowLeft") $197cd56b15c33885$var$slideLeft();
    if (e.code === "ArrowRight") $197cd56b15c33885$var$slideRight();
    if (e.code === "ArrowUp") $197cd56b15c33885$var$slideUp();
    if (e.code === "ArrowDown") $197cd56b15c33885$var$slideDown();
    if ($197cd56b15c33885$var$tilesMoved) {
        $197cd56b15c33885$var$setTwoTiles();
        $197cd56b15c33885$var$searchWinnerCell();
        $197cd56b15c33885$var$gameOver();
    }
    $197cd56b15c33885$var$tilesMoved = false;
    document.querySelector(".game-score").innerText = $197cd56b15c33885$var$score;
});
function $197cd56b15c33885$var$filterZero(row) {
    return row.filter(function(num) {
        return num !== 0;
    });
}
function $197cd56b15c33885$var$slide(row) {
    var currentRow = row;
    currentRow = $197cd56b15c33885$var$filterZero(currentRow);
    for(var i = 0; i < currentRow.length - 1; i++)if (currentRow[i] === currentRow[i + 1]) {
        currentRow[i] *= 2;
        currentRow[i + 1] = 0;
        $197cd56b15c33885$var$score += currentRow[i];
    }
    currentRow = $197cd56b15c33885$var$filterZero(currentRow);
    while(currentRow.length < $197cd56b15c33885$var$columns)currentRow.push(0);
    return currentRow;
}
function $197cd56b15c33885$var$canTilesSlide() {
    if ($197cd56b15c33885$var$hasEmptyTile()) return true;
    for(var r = 0; r < $197cd56b15c33885$var$rows; r++)for(var c = 0; c < $197cd56b15c33885$var$columns; c++){
        var tile = $197cd56b15c33885$var$board[r][c];
        if (c > 0 && tile === $197cd56b15c33885$var$board[r][c - 1]) return true;
        if (c < $197cd56b15c33885$var$columns - 1 && tile === $197cd56b15c33885$var$board[r][c + 1]) return true;
        if (r > 0 && tile === $197cd56b15c33885$var$board[r - 1][c]) return true;
        if (r < $197cd56b15c33885$var$rows - 1 && tile === $197cd56b15c33885$var$board[r + 1][c]) return true;
    }
    return false;
}
function $197cd56b15c33885$var$gameOver() {
    if (!$197cd56b15c33885$var$canTilesSlide()) $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
function $197cd56b15c33885$var$arraysEqual(originalRow, row) {
    if (originalRow.length !== row.length) return false;
    for(var i = 0; i < originalRow.length; i++){
        if (originalRow[i] !== row[i]) return false;
    }
    return true;
}
function $197cd56b15c33885$var$slideLeft() {
    for(var r = 0; r < $197cd56b15c33885$var$rows; r++){
        var row = $197cd56b15c33885$var$board[r];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row = $197cd56b15c33885$var$slide(row);
        $197cd56b15c33885$var$board[r] = row;
        for(var c = 0; c < $197cd56b15c33885$var$columns; c++){
            var tile = document.getElementById("".concat(r, "-").concat(c));
            var num = $197cd56b15c33885$var$board[r][c];
            $197cd56b15c33885$var$updateTile(tile, num);
        }
        if (!$197cd56b15c33885$var$arraysEqual(originalRow, row)) $197cd56b15c33885$var$tilesMoved = true;
    }
}
function $197cd56b15c33885$var$slideRight() {
    for(var r = 0; r < $197cd56b15c33885$var$rows; r++){
        var row = $197cd56b15c33885$var$board[r];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row.reverse();
        row = $197cd56b15c33885$var$slide(row);
        row.reverse();
        $197cd56b15c33885$var$board[r] = row;
        for(var c = 0; c < $197cd56b15c33885$var$columns; c++){
            var tile = document.getElementById("".concat(r.toString(), "-").concat(c.toString()));
            var num = $197cd56b15c33885$var$board[r][c];
            $197cd56b15c33885$var$updateTile(tile, num);
        }
        if (!$197cd56b15c33885$var$arraysEqual(originalRow, row)) $197cd56b15c33885$var$tilesMoved = true;
    }
}
function $197cd56b15c33885$var$slideUp() {
    for(var c = 0; c < $197cd56b15c33885$var$columns; c++){
        var row = [
            $197cd56b15c33885$var$board[0][c],
            $197cd56b15c33885$var$board[1][c],
            $197cd56b15c33885$var$board[2][c],
            $197cd56b15c33885$var$board[3][c]
        ];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row = $197cd56b15c33885$var$slide(row);
        for(var r = 0; r < $197cd56b15c33885$var$rows; r++){
            $197cd56b15c33885$var$board[r][c] = row[r];
            var tile = document.getElementById("".concat(r.toString(), "-").concat(c.toString()));
            var num = $197cd56b15c33885$var$board[r][c];
            $197cd56b15c33885$var$updateTile(tile, num);
        }
        if (!$197cd56b15c33885$var$arraysEqual(originalRow, row)) $197cd56b15c33885$var$tilesMoved = true;
    }
}
function $197cd56b15c33885$var$slideDown() {
    for(var c = 0; c < $197cd56b15c33885$var$columns; c++){
        var row = [
            $197cd56b15c33885$var$board[0][c],
            $197cd56b15c33885$var$board[1][c],
            $197cd56b15c33885$var$board[2][c],
            $197cd56b15c33885$var$board[3][c]
        ];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row.reverse();
        row = $197cd56b15c33885$var$slide(row);
        row.reverse();
        for(var r = 0; r < $197cd56b15c33885$var$rows; r++){
            $197cd56b15c33885$var$board[r][c] = row[r];
            var tile = document.getElementById("".concat(r.toString(), "-").concat(c.toString()));
            var num = $197cd56b15c33885$var$board[r][c];
            $197cd56b15c33885$var$updateTile(tile, num);
        }
        if (!$197cd56b15c33885$var$arraysEqual(originalRow, row)) $197cd56b15c33885$var$tilesMoved = true;
    }
}

})();
//# sourceMappingURL=index.2adc59d9.js.map
